import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  card: {
    width: "100%",
    borderRadius: "26px",
  },
  icon: {
    color: theme.palette.secondary.main,
  },
  select: {
    padding: "10px 50px 10px 10px",
  },
}))

export default styles
